<template>
  <div>
    <!-- 工具栏 -->
    <div class='navbar'>
      <el-button type='primary' icon='sys sys-refresh' class='navbarbtn'
        @click='deepRefreshMainTableContent'>
        刷 新
      </el-button>

      <el-button type='primary' icon='sys sys-upload' class='navbarbtn' v-if='showImportQRCodePower'
        @click='showImportOfflineQRCodeDialogMD'>
        线下条码录入
      </el-button>

      <el-button type='danger' icon='sys sys-batchdelete' class='navbarbtn' v-if='showBatchCancelPower'
        @click='batchCancelMainTableEditor'>
        作 废
      </el-button>

      <el-button type='danger' icon='sys sys-delete' class='navbarbtn' v-if='showBatchDeletePower'
        @click='batchDeleteMainTableEditor'>
        删 除
      </el-button>

      <ExportExcel @click='mainTableExportExcel'></ExportExcel>

      <!-- <el-button type='primary' icon='sys sys-expand' class='navbarbtn'
        @click='mainTableExpandRow'>
        展 开
      </el-button>

      <el-button type='primary' icon='sys sys-narrow' class='navbarbtn'
        @click='mainTableNarrowRow'>
        收 起
      </el-button> -->

      <TableColumnSet :columnSetLoading='mainTable.ColumnSetLoading'
        :showColumnSetDialog='mainTable.showColumnSetDialog'
        :changeShowColumnSetDialog='mainTable.changeShowColumnSetDialog'
        :columnInfo='mainTable.userColumnInfo'
        :tableInfo='mainTable.userTableInfo'
        @updateUserColumnSetDialogReset='mainTableUpdateUserColumnSetDialogReset'
        @saveUserTableColumn='mainTableSaveUserTableColumn'
        @returnDefaultTableColumn='mainTableReturnDefaultTableColumn'
        @showColumnSetDialogMD='mainTableShowColumnSetDialogMD'>
      </TableColumnSet>

      <TableFilterSet :filterSetLoading='mainTable.FilterSetLoading'
        :showFilterSetDialog='mainTable.showFilterSetDialog'
        :changeShowFilterSetDialog='mainTable.changeShowFilterSetDialog'
        :filterInfo='mainTable.userFilterInfo'
        :columnInfo='mainTable.columnInfo'
        @updateUserFilterDialogReset='mainTableUpdateUserFilterDialogReset'
        @saveUserTableFilter='mainTableSaveUserTableFilter'
        @returnDefaultTableFilter='mainTableReturnDefaultTableFilter'
        @showFilterSetDialogMD='mainTableShowFilterSetDialogMD'>
      </TableFilterSet>

      <TableFilter :filterLoading='mainTable.FilterLoading'
        :showFilterDialog='mainTable.showFilterDialog'
        :changeShowFilterDialog='mainTable.changeShowFilterDialog'
        :filterInfo='mainTable.filterInfo'
        :columnInfo='mainTable.columnInfo'
        :getSpecialStringArray='mainTableGetSpecialStringArray'
        @showFilterDialogMD='mainTableShowFilterDialogMD'
        @filter='mainTableFilter'>
      </TableFilter>

      <TableFilterOutDisplay v-for='oneFilterInfo in mainTable.filterInfo'
        :key='oneFilterInfo.ColumnCode + oneFilterInfo.FilterType'
        :getSpecialStringArray='mainTableGetSpecialStringArray'
        :columnInfo='mainTable.columnInfo'
        :oneFilterInfo='oneFilterInfo' @filter='mainTableFilter'>
      </TableFilterOutDisplay>
    </div>

    <!-- 行展开收起    :expandRowKeys='mainTable.expandRowKeys' -->
    <Table :data='mainTable.tableContent' :tableInfo='mainTable.tableInfo'
      :columnInfo='mainTable.columnInfo' :disPlayColumnInfo='mainTable.disPlayColumnInfo'
      :page-size='mainTable.pageSize' :page='mainTable.page'
      :total='mainTable.total' v-loading='mainTable.Loading'
      :reduceHeight='200' :seqFixed='true'
      :row-style='mainTableRowStyle'
      :showDefaultExpandColumn='true' :showExpandColumn='false'
      :showOperationsColumn='true' operationColumnWidth='60px'
      :getSpecialStringArray='mainTableGetSpecialStringArray'
      @selection-change='mainTableSelectionChange'
      @page-change='mainTablePageChange' @size-change='mainTableSizeChange'
      @sort-change='mainTableSortChange'>
      <template #OperationColumnslot='scope'>
        <el-tooltip effect='dark' content='作废' placement='top-start'
          v-if='showCancelPower && scope.data.row.Status === "0" && scope.data.row.InitType === "1" && scope.data.row.InitQty === scope.data.row.Qty'>
          <el-button type='danger' circle style='padding: 4px;' @click='cancelOneMainTableEditor(scope)'><i class='sys sys-batchdelete'></i></el-button>
        </el-tooltip>
        <el-tooltip effect='dark' content='删除' placement='top-start'
          v-if='showDeletePower && scope.data.row.Status === "9" && scope.data.row.InitType === "1" && scope.data.row.InitQty === scope.data.row.Qty'>
          <el-button type='danger' circle style='padding: 4px;' @click='deleteOneMainTableEditor(scope)'><i class='sys sys-delete'></i></el-button>
        </el-tooltip>
      </template>
    </Table>

    <el-dialog title='线下条码录入' :visible.sync='showImportOfflineQRCodeDialog' fullscreen>
      <div style='margin-top: -30px;'>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          送货单号
        </div>
        <TableSelect v-model='deliveryBillNo'
          class='inputField-input' ref='deliveryBillNoTableSelect'
          :displayValue='""'
          returnCode='DeliveryBillNo' displayCode='DeliveryBillNo' disabled
          style='width: 200px;' tableCode='PO_DeliveryBill'></TableSelect>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          扫描条码
        </div>
        <el-input v-model='scanQRCode' size='mini' class='inputField-input'
          @keyup.enter.native='scanQRCodeEnterMD' style='width: 120px;'>
        </el-input>
        <el-button type='primary' @click='offlineQRCodeImport()' size='mini'>录入</el-button>
        <el-button @click='showImportOfflineQRCodeDialog = false' size='mini'>取消</el-button>
      </div>
      <el-table :data='scanQRCodes' border :height='getScanQRCodesTableHeight()'
        ref='scanQRCodesTable' style='margin-top: 10px;'
        :cell-style='mainTableCellStyle' row-key='OuterQRCode' default-expand-all
        :header-cell-style='mainTableHeaderCellStyle' size='medium'>
        <el-table-column type='expand' fixed>
          <template #default='scope'>
            <div class='expand'>
              <div class='expand-inner'>
                <div class='expand-row' style='font-weight: 800; min-width: 30px; text-align: right;'><span style='color: #42426F;'> </span></div>
                <div class='expand-row' style='font-weight: 800; min-width: 60px; text-align: right;'><span style='color: #42426F;'>行号</span></div>
                <div class='expand-row' style='font-weight: 800; min-width: 200px; text-align: left;'><span style='color: #42426F;'>内箱标签号</span></div>
                <div class='expand-row' style='font-weight: 800; min-width: 100px; text-align: right;'><span style='color: #42426F;'>数量</span></div>
                <div class='expand-row' style='font-weight: 800; min-width: 150px; text-align: left;'><span style='color: #42426F;'>供应商批号</span></div>
              </div>
            </div>
            <div class='expand'>
              <div v-for='(qrCode, qrCodeIndex) in scope.row.NQRCodes'
                :key='qrCode.QRCode' class='expand-inner'>
                <div class='expand-row' style='min-width: 30px; text-align: right;'><span style='color: red;'><i class='sys sys-no' @click='deleteOneNQRCode(scope.row, qrCodeIndex, scope.$index)'/></span></div>
                <div class='expand-row' style='min-width: 60px; text-align: right;'><span style='color: #42426F;'>{{qrCodeIndex + 1}} </span></div>
                <div class='expand-row' style='min-width: 200px; text-align: left;'><span style='color: #42426F;'>{{qrCode.QRCode}} </span></div>
                <div class='expand-row' style='min-width: 100px; text-align: right;'><span style='color: #42426F;'>{{qrCode.Qty}}{{scope.row.UnitName}} </span></div>
                <div class='expand-row' style='min-width: 150px; text-align: left;'><span style='color: #42426F;'>{{qrCode.SupplyBatchNo}} </span></div>
                </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column type='index' label='序号' width='60'>
        </el-table-column>
        <el-table-column prop='OuterQRCode' label='外箱标签号' width='200'>
        </el-table-column>
        <el-table-column prop='ItemNumber' label='物料代码' width='300'>
        </el-table-column>
        <el-table-column prop='ItemName' label='物料名称' width='350'>
        </el-table-column>
        <el-table-column prop='ItemModel' label='规格' width='200'>
        </el-table-column>
        <el-table-column prop='PackageQty' label='包数' width='60'>
        </el-table-column>
        <el-table-column prop='Qty' label='数量' width='60'>
        </el-table-column>
        <el-table-column prop='UnitName' label='单位' width='60'>
        </el-table-column>
        <el-table-column prop='ProducetItemID' label='专用产品号' width='160'>
        </el-table-column>
        <el-table-column prop='OuterQRCodeVal' label='外箱标签值' width='600' show-overflow-tooltip>
        </el-table-column>
        <el-table-column label='操作' width='60' fixed='right'>
          <template #default='scope'>
            <el-button type='danger' circle style='padding: 4px;'
              @click='deleteScanQRCode(scope.$index)'><i class='sys sys-delete'></i>
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import table from '@/components/sys/Table'
import Table from '@/components/sys/Table.vue'
import tableColumnSet from '@/components/sys/TableColumnSet'
import TableColumnSet from '@/components/sys/TableColumnSet.vue'
import tableFilterSet from '@/components/sys/TableFilterSet'
import TableFilterSet from '@/components/sys/TableFilterSet.vue'
import tableFilter from '@/components/sys/TableFilter'
import TableFilter from '@/components/sys/TableFilter.vue'
import TableFilterOutDisplay from '@/components/sys/TableFilterOutDisplay.vue'
import TableSelect from '@/components/custom/TableSelect.vue'
import exportExcelHelper from '@/components/export/ExportExcelHelper'
import ExportExcel from '@/components/export/ExportExcel.vue'
import power from '@/components/sys/Power'
import { Loading } from 'element-ui'
import axiosHelper from '@/utils/axiosHelper'
import dateTimeUtil from '@/utils/dateTimeUtil'

export default {
  name: 'OfflineQRCodeImport',
  components: {
    Table: Table,
    TableColumnSet: TableColumnSet,
    TableFilterSet: TableFilterSet,
    TableFilter: TableFilter,
    TableFilterOutDisplay: TableFilterOutDisplay,
    ExportExcel: ExportExcel,
    TableSelect: TableSelect
  },
  metaInfo: function () {
    return {
      title: this.menuName
    }
  },
  data: function () {
    return {
      menuCode: '',
      menuName: '',
      mainTable: {
        tableCode: 'WMS_QRCode_PO_Offline',
        tableInfo: {},
        columnInfo: [],
        disPlayColumnInfo: [],
        tableContent: [],
        pageSize: 50,
        page: 1,
        total: 0,
        defaultOrderStr: '',
        orderStr: '',
        defaultFilterStr: '',
        filterStr: '',
        Loading: false,

        userColumnInfo: [],
        userTableInfo: {},
        showColumnSetDialog: false,
        changeShowColumnSetDialog: false,
        ColumnSetLoading: false,

        userFilterInfo: [],
        showFilterSetDialog: false,
        changeShowFilterSetDialog: false,
        FilterSetLoading: false,

        filterInfo: [],
        showFilterDialog: false,
        changeShowFilterDialog: false,
        FilterLoading: false,

        selections: [],
        expandRowKeys: []
      },

      showImportOfflineQRCodeDialog: false,
      scanQRCodes: [],
      scanQRCode: '',
      deliveryBillNo: '',

      showCancelPower: false,
      showDeletePower: false,
      showBatchCancelPower: false,
      showBatchDeletePower: false,
      showImportQRCodePower: false
    }
  },

  computed: {
    codes: function () {
      return this.$store.state.codes
    }
  },

  created: async function () {
    const that = this
    that.menuCode = that.$route.path.substring(1)
    that.menuName = that.$route.meta.title
    power.setPower(that)

    const tableContentPromise = table.refreshTableStructure(that, 'mainTable')
    const tableFilterInfoPromise = tableFilter.refreshTableFliter(that, 'mainTable')

    await tableContentPromise
    await tableFilterInfoPromise
  },

  methods: {
    // 页面主表格深度刷新方法
    deepRefreshMainTableContent: function () {
      const that = this
      that.mainTable.filterStr = that.mainTable.defaultFilterStr
      that.mainTable.orderStr = that.mainTable.defaultOrderStr
      that.refreshMainTableContent()
    },

    // 页面主表格刷新方法
    refreshMainTableContent: function () {
      const that = this
      table.refreshTableContent(that, 'mainTable')
    },

    // 页面主表格换页方法
    mainTablePageChange: function (val) {
      const that = this
      that.mainTable.page = val
      that.refreshMainTableContent()
    },

    // 页面主表格改变每页显示数据条数方法
    mainTableSizeChange: function (val) {
      const that = this
      that.mainTable.page = 1
      that.mainTable.pageSize = val
      that.refreshMainTableContent()
    },

    // 页面主表格排序方式变更方法
    mainTableSortChange: function (column) {
      const that = this
      table.sortChange(column, that, 'mainTable')
    },

    // 页面主表格多选方法
    mainTableSelectionChange: function (selections, row) {
      const that = this
      that.mainTable.selections = selections
    },

    // 页面主表格过滤弹出框显示方法
    mainTableShowFilterDialogMD: function () {
      const that = this
      tableFilter.showTableFliter(that, 'mainTable')
    },

    // 页面主表格过滤方法
    mainTableFilter: function () {
      const that = this
      tableFilter.filter(that, 'mainTable')
    },

    // 页面主表格栏目设置弹框显示方法
    mainTableShowColumnSetDialogMD: function () {
      const that = this
      tableColumnSet.showTableColumnSet(that, 'mainTable')
    },

    // 页面主表格栏目设置重置方法
    mainTableUpdateUserColumnSetDialogReset: function () {
      const that = this
      tableColumnSet.resetTableColumnSet(that, 'mainTable')
    },

    // 页面主表格栏目设置保存方法
    mainTableSaveUserTableColumn: function () {
      const that = this
      tableColumnSet.saveUserTableColumn(that, 'mainTable')
    },

    // 页面主表格栏目设置恢复默认方法
    mainTableReturnDefaultTableColumn: function () {
      const that = this
      tableColumnSet.returnDefaultTableColumn(that, 'mainTable')
    },

    // 页面主表格过滤设置弹框显示方法
    mainTableShowFilterSetDialogMD: function () {
      const that = this
      tableFilterSet.showTableFliterSet(that, 'mainTable')
    },

    // 页面主表格过滤设置重置方法
    mainTableUpdateUserFilterDialogReset: function () {
      const that = this
      tableFilterSet.resetTableFilterSet(that, 'mainTable')
    },

    // 页面主表格过滤设置保存方法
    mainTableSaveUserTableFilter: function () {
      const that = this
      tableFilterSet.saveUserTableFilter(that, 'mainTable')
    },

    // 页面主表格过滤设置恢复默认方法
    mainTableReturnDefaultTableFilter: function () {
      const that = this
      tableFilterSet.returnDefaultTableFilter(that, 'mainTable')
    },

    // 主表行展开方法
    mainTableExpandRow: function () {
      const that = this
      table.expandRow(that, 'mainTable')
    },

    // 主表行收起方法
    mainTableNarrowRow: function () {
      const that = this
      table.narrowRow(that, 'mainTable')
    },

    // 特征字符串转换方法
    mainTableGetSpecialStringArray: function (columnCode) {
      return []
    },

    // 页面主表格行样式设定方法
    mainTableRowStyle: function (data, rowIndex) {
      if (data.row.Status === '9') {
        return { 'background-color': '#aaaaaa' }
      } else if (data.row.Status === '2') {
        return { 'background-color': 'lightblue' }
      } else if (data.row.Status === '1') {
        return { 'background-color': 'lightgreen' }
      } else if (data.row.Status === '7') {
        return { 'background-color': 'orange' }
      } else if (data.row.Status === '8') {
        return { 'background-color': 'Violet' }
      } else if (data.row.Status === 'S') {
        return { 'background-color': 'Pink' }
      } else {
        return {}
      }
    },

    // 主表数据导出为Excel
    mainTableExportExcel: function () {
      const that = this
      exportExcelHelper.exportSYSTableToExcel(that, 'mainTable')
    },

    // 线下条码扫描录入弹出框显示方法
    showImportOfflineQRCodeDialogMD: function () {
      const that = this
      that.showImportOfflineQRCodeDialog = true
      that.scanQRCodes = []
      that.scanQRCode = ''
      that.$nextTick(() => {
        that.$refs.deliveryBillNoTableSelect.setSelected('', '')
      })
    },

    // 表格单元格样式
    mainTableCellStyle: function () {
      return { padding: '0px' }
    },

    // 表格表头单元格样式
    mainTableHeaderCellStyle: function ({ column, columnIndex, row, rowIndex }) {
      return { padding: '5px', 'background-color': '#f5f7fa' }
    },

    // 获取线下条码录入扫描标签表格高度
    getScanQRCodesTableHeight: function () {
      return window.innerHeight - 140 + 'px'
    },

    // 扫码回车事件
    scanQRCodeEnterMD: async function () {
      const that = this
      if (!that.scanQRCode) {
        return
      }
      const scanQRCodeRow = {}
      const scanQRCodeSplits = that.scanQRCode.split('|')
      if (scanQRCodeSplits.length < 7) {
        that.scanQRCode = ''
        that.$message.error('请确认扫描的是外箱条码!')
        return
      }
      scanQRCodeRow.OuterQRCode = scanQRCodeSplits[0]
      scanQRCodeRow.QRCodeType = '0'
      scanQRCodeRow.ItemNumber = scanQRCodeSplits[2]
      scanQRCodeRow.SupplyNumber = scanQRCodeSplits[3]
      scanQRCodeRow.POOrderBillNo = scanQRCodeSplits[4]
      scanQRCodeRow.KFDate = scanQRCodeSplits[5]
      if (scanQRCodeSplits.length > 7) {
        scanQRCodeRow.ProducetItemID = scanQRCodeSplits[7]
      }
      for (let i = 0; i < that.scanQRCodes.length; i++) {
        if (scanQRCodeRow.OuterQRCode === that.scanQRCodes[i].OuterQRCode) {
          that.scanQRCode = ''
          that.$message.error('该外箱条码已扫描!')
          return
        }
        if (scanQRCodeRow.OuterQRCode.indexOf(scanQRCodeRow.SupplyNumber) < 0) {
          that.scanQRCode = ''
          that.$message.error('外箱标签号中供应商不匹配!')
          return
        }
      }
      if (!dateTimeUtil.checkDateTimeStr(scanQRCodeRow.KFDate, 'yyyyMMdd')) {
        that.scanQRCode = ''
        that.$message.error('外箱标签号中的生产日期格式不正确!')
        return
      }

      if (!scanQRCodeRow.OuterQRCode || scanQRCodeRow.OuterQRCode.substring(0, 1) !== 'W') {
        that.scanQRCode = ''
        that.$message.error('请确认扫描的是外箱条码!')
        return
      }
      if (!scanQRCodeSplits[1] || scanQRCodeSplits[1] !== 'B') {
        that.scanQRCode = ''
        that.$message.error('请确认扫描的是外箱条码!')
        return
      }
      const scanQRCodeRowDetail = []
      const scanQRCodeRowDetailSplits = scanQRCodeSplits[6].split(';')
      for (let i = 0; i < scanQRCodeRowDetailSplits.length; i++) {
        if (scanQRCodeRowDetailSplits[i] === '') {
          continue
        }
        const scanQRCodeRowDetailSplitStrs = scanQRCodeRowDetailSplits[i].split(',')
        if (scanQRCodeRowDetailSplitStrs.length !== 3) {
          that.scanQRCode = ''
          that.$message.error('请确认扫描的外箱条码格式正确!')
          return
        }
        if (scanQRCodeRowDetailSplitStrs[0].indexOf(scanQRCodeRow.SupplyNumber) < 0) {
          that.scanQRCode = ''
          that.$message.error('内箱标签号中供应商不匹配!')
          return
        }
        for (let k = 0; k < that.scanQRCodes.length; k++) {
          for (let j = 0; j < that.scanQRCodes[k].NQRCodes.length; j++) {
            if (that.scanQRCodes[k].NQRCodes[j].QRCode === scanQRCodeRowDetailSplitStrs[0]) {
              that.scanQRCode = ''
              that.$message.error('该外箱条码中的内箱条码【' + that.scanQRCodes[k].NQRCodes[j].QRCode + '】已在之前的外箱条码【' +
                that.scanQRCodes[k].OuterQRCode + '】中存在!')
              return
            }
          }
        }
        scanQRCodeRowDetail.push({
          QRCode: scanQRCodeRowDetailSplitStrs[0],
          SupplyBatchNo: scanQRCodeRowDetailSplitStrs[1],
          Qty: scanQRCodeRowDetailSplitStrs[2]
        })
      }
      scanQRCodeRow.NQRCodes = scanQRCodeRowDetail
      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebAction/PurchaseManage.POOrder.OfflineQRCodeScanCheck', {
        scanOuterQRCode: scanQRCodeRow,
        deliveryBillNo: that.deliveryBillNo
      })
      if (rtnObj.error === '000000') {
        const rtnDevInfo = JSON.parse(rtnObj.msg.replace(/'/g, '"'))
        if (!that.deliveryBillNo) {
          that.$refs.deliveryBillNoTableSelect.setSelected(rtnDevInfo.DeliveryBillNo, rtnDevInfo.DeliveryBillNo)
        }
        scanQRCodeRow.ItemID = rtnDevInfo.ItemID
        scanQRCodeRow.SupplyID = rtnDevInfo.SupplyID
        scanQRCodeRow.POInterID = rtnDevInfo.POInterID
        scanQRCodeRow.OuterQRCodeVal = that.scanQRCode
        scanQRCodeRow.UnitID = rtnDevInfo.UnitID
        scanQRCodeRow.UnitName = rtnDevInfo.UnitName
        scanQRCodeRow.ItemName = rtnDevInfo.ItemName
        scanQRCodeRow.ItemModel = rtnDevInfo.ItemModel
        scanQRCodeRow.Qty = rtnDevInfo.Qty
        scanQRCodeRow.PackageQty = rtnDevInfo.PackageQty
        scanQRCodeRow.KFPeriod = rtnDevInfo.KFPeriod
        scanQRCodeRow.KFDate = dateTimeUtil.formartDateTime(dateTimeUtil.dateTimeStrToDateTime(scanQRCodeRow.KFDate, 'yyyyMMdd'), 'yyyy-MM-dd')
        scanQRCodeRow.BatchNo = scanQRCodeRow.KFDate.replace(/-/g, '')
        that.scanQRCodes.push(scanQRCodeRow)
        that.scanQRCode = ''
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    },

    // 扫描标签表行删除事件
    deleteScanQRCode: function (index) {
      const that = this
      that.scanQRCodes.splice(index, 1)
      if (that.scanQRCodes.length === 0) {
        that.$refs.deliveryBillNoTableSelect.setSelected('', '')
      }
    },

    // 扫描标签表内箱标签行删除事件
    deleteOneNQRCode: function (row, index, outIndex) {
      const that = this
      that.$confirm('确定要删除该内箱标签吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        row.Qty -= row.NQRCodes[index].Qty
        row.PackageQty -= 1
        row.NQRCodes.splice(index, 1)
        if (row.NQRCodes.length === 0) {
          that.scanQRCodes.splice(outIndex, 1)
          if (that.scanQRCodes.length === 0) {
            that.$refs.deliveryBillNoTableSelect.setSelected('', '')
          }
        }
      }).catch(() => {
      })
    },

    // 线下条码录入
    offlineQRCodeImport: async function () {
      const that = this
      if (that.scanQRCodes.length <= 0) {
        that.$message.error('请扫码')
        return
      }
      if (!that.deliveryBillNo) {
        that.$message.error('请选择送货单！')
        return
      }
      const loadingInstance = Loading.service({ fullscreen: true })
      const importNQRCodes = []
      for (let k = 0; k < that.scanQRCodes.length; k++) {
        for (let j = 0; j < that.scanQRCodes[k].NQRCodes.length; j++) {
          importNQRCodes.push({
            QRCode: that.scanQRCodes[k].NQRCodes[j].QRCode,
            OuterQRCode: that.scanQRCodes[k].OuterQRCode,
            OuterQRCodeVal: that.scanQRCodes[k].OuterQRCodeVal,
            SupplyID: that.scanQRCodes[k].SupplyID,
            ItemID: that.scanQRCodes[k].ItemID,
            SupplyBatchNo: that.scanQRCodes[k].NQRCodes[j].SupplyBatchNo,
            Qty: that.scanQRCodes[k].NQRCodes[j].Qty,
            POInterID: that.scanQRCodes[k].POInterID,
            UnitID: that.scanQRCodes[k].UnitID,
            KFPeriod: that.scanQRCodes[k].KFPeriod,
            BatchNo: that.scanQRCodes[k].BatchNo,
            KFDate: that.scanQRCodes[k].KFDate,
            ItemNumber: that.scanQRCodes[k].ItemNumber,
            ProducetItemID: that.scanQRCodes[k].ProducetItemID
          })
        }
      }
      const rtnObj = await axiosHelper.handle('/WebAction/PurchaseManage.POOrder.OfflineQRCodeImport', {
        importNQRCodes: importNQRCodes,
        deliveryBillNo: that.deliveryBillNo
      })
      if (rtnObj.error === '000000') {
        that.refreshMainTableContent()
        that.showImportOfflineQRCodeDialog = false
        that.$message.success('条码录入成功！')
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    },

    // 表格编辑器数据批量作废方法
    cancelMainTableEditor: async function (selectedTableEditorContent) {
      const that = this
      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebAction/PurchaseManage.POOrder.CancelPOQRCode', {
        rows: selectedTableEditorContent
      })
      if (rtnObj.error === '000000') {
        that.refreshMainTableContent()
        that.$message.success('恭喜你，作废标签成功！')
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    },

    // 表格编辑器作废某行数据确认弹出框显示方法
    cancelOneMainTableEditor: async function (scope) {
      const that = this
      that.$confirm('此操作将永久作废该标签吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.cancelMainTableEditor([scope.data.row])
      }).catch(() => {
      })
    },

    // 表格编辑器批量作废确认弹出框显示方法
    batchCancelMainTableEditor: async function () {
      const that = this
      if (that.mainTable.selections.length <= 0) {
        that.$message.error('请选择数据！')
        return
      }
      that.$confirm('此操作将永久作废这些标签, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.cancelMainTableEditor(that.mainTable.selections)
      }).catch(() => {
      })
    },

    // 表格编辑器数据批量删除方法
    deleteMainTableEditor: async function (selectedTableEditorContent) {
      const that = this
      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebAction/PurchaseManage.POOrder.DeletePOQRCode', {
        rows: selectedTableEditorContent
      })
      if (rtnObj.error === '000000') {
        that.refreshMainTableContent()
        that.$message.success('恭喜你，删除标签成功！')
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    },

    // 表格编辑器删除某行数据确认弹出框显示方法
    deleteOneMainTableEditor: async function (scope) {
      const that = this
      that.$confirm('此操作将永久删除该标签吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.deleteMainTableEditor([scope.data.row])
      }).catch(() => {
      })
    },

    // 表格编辑器批量删除确认弹出框显示方法
    batchDeleteMainTableEditor: async function () {
      const that = this
      if (that.mainTable.selections.length <= 0) {
        that.$message.error('请选择数据！')
        return
      }
      that.$confirm('此操作将永久删除这些标签, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.deleteMainTableEditor(that.mainTable.selections)
      }).catch(() => {
      })
    }
  }
}
</script>

<style scoped>
.navbar {
  padding-bottom: 0px;
  width: 100%;
  padding: 0;
  margin-bottom: 5px;
  margin-top: -10px;
  float: left;
}
.expand {
  padding-left: 46px;
}
.expand-inner {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}
.expand-row {
  margin-right: 10px;
  padding-left: 20p;
  color: blue;
  white-space: nowrap;
}
.inputField-label {
  font-size: 14px;
  color: #606266;
  padding-right: 10px;
  vertical-align: middle;
  line-height: 28px;
  float: left;
}
.inputField-input {
  margin-right: 10px;
  float: left;
}
</style>
